export enum ConfirmDialogResponseEnum {
  CONFIRM = "CONFIRM",
  CANCEL = "CANCEL",
  THIRD_ACTION = "THIRD_ACTION",
}
